import React from "react";
import "./HeroAbout.css";
import { useNavigate } from "react-router-dom";
export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="heroabout" id="heroabout">
      {/* ✅ Overlay for better contrast */}
      <div className="heroabout-overlayabout"></div>
      <div className="heroabout-contentabout">
        <h1>About Glamur Paints </h1>
        <h2>Four Decades of Painting Excellence in Pakistan</h2>
        <button className="ctaabout-btnabout" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
